<template>
  <div :class="`${AppConfig.theme}-theme`">
    <label class="label-top">{{ props.label }}</label>
    <div class="star-rating">
      <label class="label-border">{{ props.label }}</label>
      <p class="star-description">{{ props.description }}</p>
      <Rating v-model="model" v-bind="$attrs" :cancel="false" :disabled="props.disabled"/>
      <input style="display: none;" type="text" :required="props.required" v-model="model" v-bind="$attrs" :disabled="props.disabled" />
    </div>
  </div>
</template>

<script setup>
import { computed, reactive } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import AppConfig from '~/config/appConfig.js'

const props = defineProps({
  label: String,
  description: String,
  required: Boolean,
  disabled: { type: Boolean, default: false }
})

const model = defineModel()

const value = reactive(model)

const rules = computed(() => {
  const v = {}
  if (props.required && !props.disabled) {
    v.value = { required }
  } else {
    v.value = {}
  }
  return v
})

const v$ = useVuelidate(rules, { value })
</script>

<style scoped>
label {
  font-weight: 550;
  color: #013315;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
}

.label-top {
  display: none;
}

.label-border {
  margin-bottom: 12px;
  display: block;
}

@media screen and (min-width: 768px) {
  .label-top {
    display: block;
  }

  .label-border {
    display: none;
  }
}

.star-rating {
  padding: 16px 12px;
  box-shadow: 1px 2px 4px #00000029;
  border: 0.5px solid #F2F2F2;
  border-radius: 8px;
}

.star-description {
  margin-bottom: 8px;
}

.sbg-theme {
  .label-top {
    display: none;
  }
  .label-border {
    display: block;
  }
  
  .star-rating {
    box-shadow: none;
    border: 1px solid rgba(0, 0, 0, 0.38);
  }
}

</style>
